import { render, staticRenderFns } from "./CompanyOEAttachments.vue?vue&type=template&id=f27a8a60&scoped=true&"
import script from "./CompanyOEAttachments.vue?vue&type=script&lang=js&"
export * from "./CompanyOEAttachments.vue?vue&type=script&lang=js&"
import style0 from "./CompanyOEAttachments.vue?vue&type=style&index=0&id=f27a8a60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27a8a60",
  null
  
)

export default component.exports